export default __webpack_public_path__ + "static/media/Sabrina@2x.0967638b.jpg";